import _mapInstanceProperty from "@babel/runtime-corejs3/core-js/instance/map";
import React from "react";
import PropTypes from "prop-types";
import classesPropType from "@xo-union/classes-prop-type";
import ListItem from "../ListItem/index.js";
import List from "../List/index.js";
import labelize from "../../utils/labelize.js";

var SuggestionList = function SuggestionList(props) {
  var classes = props.classes,
      emptyLabel = props.emptyLabel,
      suggestions = props.suggestions,
      renderSuggestion = props.renderSuggestion,
      idKey = props.idKey,
      labelKey = props.labelKey;
  var listItems = React.createElement(ListItem, {
    classes: classes,
    disabled: true
  }, emptyLabel);

  if (suggestions.length > 0) {
    listItems = _mapInstanceProperty(suggestions).call(suggestions, function (suggestion, idx) {
      return React.createElement(ListItem, {
        key: idKey ? labelize(suggestion, idKey) : idx,
        suggestion: suggestion,
        position: idx,
        classes: classes
      }, renderSuggestion ? renderSuggestion(suggestion, props, idx) : labelize(suggestion, labelKey));
    });
  }

  return React.createElement(List, {
    classes: classes
  }, listItems);
};

process.env.NODE_ENV !== "production" ? SuggestionList.propTypes = {
  emptyLabel: PropTypes.string,
  idKey: PropTypes.oneOfType([PropTypes.string, PropTypes.func]),
  suggestions: PropTypes.oneOfType([PropTypes.arrayOf(PropTypes.object.isRequired), PropTypes.arrayOf(PropTypes.string.isRequired)]).isRequired,
  renderSuggestion: PropTypes.func,
  labelKey: PropTypes.oneOfType([PropTypes.string, PropTypes.func]),
  classes: classesPropType(['container', 'is-open', 'list-container', 'list', 'list-item', 'is-disabled', 'is-active'])
} : void 0;
export default SuggestionList;